module.exports = __webpack_public_path__ + "portal-static/img/other_btn.a24ca058.png";